import { styledComponent, Grid, Box, Skeleton, Divider } from '@hermes/web-components'

const defaultGradient = 'linear-gradient(90deg, #E7EAEF 0%, #E2E0E0 100%)'
const keywordGradient = 'linear-gradient(90deg, #E6FCFA 0%, #9FFCF3 100%)'

export const CardContainer = styledComponent(Grid)(({ theme }) => ({
  width: '100%',
  borderRadius: '16px',
  border: '1px solid #D5DEF9',
  padding: '24px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column'
  }
}))

export const TopContentSection = styledComponent(Grid)(({ theme }) => ({
  width: '60%',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}))

export const BottomContentSection = styledComponent(Grid)(({ theme }) => ({
  width: '40%',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}))

export const IntroSection = styledComponent(Grid)({
  alignItems: 'center',
  gap: '16px'
})

export const IntroDescriptionBox = styledComponent(Box)({
  width: '30%'
})

export const DescriptionSection = styledComponent(Grid)({
  margin: '16px 0'
})

export const RatingSection = styledComponent(Grid)({
  justifyContent: 'flex-end',
  gap: '16px'
})

export const KeywordsSection = styledComponent(Grid)(({ theme }) => ({
  gap: '12px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '16px'
  }
}))

export const EmptyButton = styledComponent(Box)(({ theme }) => ({
  height: '40px',
  width: '70%',
  borderRadius: '24px',
  border: '1px solid #2B59E0',
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}))

export const AvatarSkeleton = styledComponent(Skeleton)(({ theme }) => ({
  width: '104px',
  height: '104px',
  background: defaultGradient,
  [theme.breakpoints.down('sm')]: {
    width: '80px',
    height: '80px'
  }
}))

export const TopIntroTextSkeleton = styledComponent(Skeleton)({
  width: '70%',
  height: '20px',
  background: defaultGradient,
  marginBottom: '11px'
})

export const BottomIntroTextSkeleton = styledComponent(Skeleton)({
  width: '100%',
  height: '20px',
  background: defaultGradient,
  marginBottom: '11px'
})

export const TopDescriptionTextSkeleton = styledComponent(Skeleton)({
  width: '100%',
  background: defaultGradient
})

export const BottomDescriptionTextSkeleton = styledComponent(Skeleton)(({ theme }) => ({
  width: '80%',
  background: defaultGradient,
  [theme.breakpoints.down('sm')]: {
    marginBottom: '16px'
  }
}))

export const KeywordsTextSkeleton = styledComponent(Skeleton)({
  width: '20%',
  background: defaultGradient
})

export const KeywordSkeleton = styledComponent(Skeleton)({
  width: '95px',
  height: '22px',
  background: keywordGradient,
  borderRadius: '24px'
})

export const RatingButton = styledComponent(Skeleton)(({ theme }) => ({
  height: '112px',
  width: '70%',
  background: defaultGradient,
  [theme.breakpoints.down('sm')]: {
    width: '100%'
  }
}))

export const StyledDivider = styledComponent(Divider)(() => ({
  width: '100%',
  borderColor: '#D5DEF9'
}))
